// extracted by mini-css-extract-plugin
export default {"reports":"Reports_reports__bnSIR"};